import { useState } from 'react';
import { Link } from 'react-router-dom';
import VoiceInputButton from '@/components/VoiceInputButton';

export function Activity({ activity, reflection, setReflection }) {
  const [state, setState] = useState({});
  if (!activity) return null;
  const { kind, prompt, options, items } = activity;

  return (
    <div>
      <p className="text-[10px] uppercase tracking-widest text-gold font-semibold mb-3">Interactive Reflection</p>
      <h2 className="font-heading text-2xl sm:text-3xl text-navy mb-8 leading-tight">{prompt}</h2>

      {kind === 'quiz' && (
        <div className="space-y-3">
          {options.map((opt, i) => {
            const picked = state.picked === i;
            const revealed = state.picked !== undefined;
            const isCorrect = opt.correct;
            const cls = !revealed
              ? 'border-navy/15 hover:bg-beige/60'
              : picked
                ? (isCorrect ? 'border-green bg-green/10' : 'border-red-400 bg-red-50')
                : (isCorrect ? 'border-green bg-green/10' : 'border-navy/10 opacity-60');
            return (
              <button
                key={i}
                onClick={() => !revealed && setState({ picked: i })}
                data-testid={`quiz-opt-${i}`}
                className={`w-full text-left p-5 rounded-2xl border-2 transition-smooth ${cls}`}>
                <p className="text-navy font-medium">{opt.text}</p>
                {revealed && (picked || isCorrect) && (
                  <p className="text-sm text-navy/70 mt-3 leading-relaxed">{opt.why}</p>
                )}
              </button>
            );
          })}
        </div>
      )}

      {kind === 'self_rating' && (
        <div className="bg-beige rounded-3xl p-8">
          <input
            type="range" min={1} max={10}
            value={state.val || 5}
            onChange={(e) => setState({ val: parseInt(e.target.value) })}
            data-testid="self-rating-slider"
            className="w-full accent-navy"/>
          <div className="flex justify-between text-xs text-navy/60 mt-2"><span>1</span><span>5</span><span>10</span></div>
          <p className="text-center mt-6 text-navy">You: <span className="font-heading text-4xl text-gold">{state.val || 5}</span></p>
          {items && (
            <div className="flex justify-between text-[11px] text-navy/50 mt-6">
              {items.map((label, i) => <span key={i}>{label}</span>)}
            </div>
          )}
        </div>
      )}

      {kind === 'checklist' && (
        <div className="space-y-2">
          {items.map((it, i) => {
            const checked = !!state[`c${i}`];
            return (
              <label key={i} data-testid={`checklist-${i}`}
                className="flex items-center gap-3 p-4 rounded-2xl bg-white border border-navy/10 hover:bg-beige/60 cursor-pointer transition-smooth">
                <input type="checkbox" checked={checked}
                  onChange={() => setState(s => ({ ...s, [`c${i}`]: !checked }))}
                  className="w-5 h-5 accent-navy"/>
                <span className="text-navy">{it}</span>
              </label>
            );
          })}
          <p className="text-sm text-navy/60 mt-4 text-center">
            {Object.values(state).filter(Boolean).length} of {items.length} checked
          </p>
        </div>
      )}

      {kind === 'reflection' && (
        <div>
          <div className="relative">
            <textarea
              rows={7}
              value={reflection}
              onChange={(e) => setReflection(e.target.value)}
              data-testid="reflection-textarea"
              placeholder="Write your thoughts here — everything you type stays private and autosaves."
              className="w-full bg-white border border-navy/10 rounded-2xl p-5 pr-14 focus:outline-none focus:ring-2 focus:ring-gold text-navy leading-relaxed text-[16px]"/>
            <div className="absolute right-3 bottom-3">
              <VoiceInputButton compact testid="lesson-activity-voice-btn"
                onTranscript={(chunk) => setReflection(prev => (prev + ' ' + chunk).trim())}/>
            </div>
          </div>
          <p className="text-xs text-navy/50 mt-2">Autosaved locally · <Link to="/app/journal" className="underline">Save to Journal</Link></p>
        </div>
      )}
    </div>
  );
}
